























import { Component, Vue, Prop } from "vue-property-decorator";
import * as modules from "../../../store/decorator";
import axios from "axios";

@Component
export default class VPurchaseOrder extends Vue {
    @Prop(String) value!: string;
    @Prop(String) id!: string;
    @Prop(String) status!: string;
    @Prop(String) sheetId!: string;
    @Prop(String) sheetRow!: string;

    purchaseOrder: string = "";
    loading: boolean = false;

    async save() {
        this.loading = true;

        const purchaseOrder = this.purchaseOrder.trim();

        if (this.purchaseOrder !== purchaseOrder) {
            this.purchaseOrder = purchaseOrder;
        }

        var orderStatus = purchaseOrder ? "Approved" : "Pending";

        await this.$http
            .put(
                process.env.VUE_APP_V3_CCTV_UPLOAD_PURCHASE,
                {
                    id: this.sheetRow,
                    purchase: purchaseOrder,
                    status: orderStatus
                },
                {
                    headers: {
                        Authorization: process.env.VUE_APP_V3_API_KEY
                    }
                }
            )
            .then(response => {
                this.$emit("get-history");
            })
            .then(response => {
                this.loading = false;

                if (purchaseOrder)
                    return modules.root.snackbar("Purchase order added");
                return modules.root.snackbar("Purchase order removed");
            })
            .catch((error: any) => modules.root.errorAlert());
    }
}
